exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerwrap[data-v-ec42a0a0]{width:100%;height:80px;position:fixed;bottom:0;left:0;background:#434343;text-align:center;color:#f6fcfc}.footerwrap .footer .p1[data-v-ec42a0a0]{margin:8px 0;line-height:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ec42a0a0","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 9rwF
// module chunks = 1